module.exports = __webpack_public_path__ + "static/img/top.14b957a9.jpg";